import { Dialog } from "@blueprintjs/core";
import { observer } from "mobx-react";
import { AppLogo } from "modules/root/components/logo/AppLogo";
import React from "react";
import { AuthForm, AuthFormProps } from "./AuthForm";
import { DeviceStep } from "./DeviceStep";
import { AccessBlockedStep } from "./AccessBlockedStep";
import styles from "./AuthDialog.module.scss";

/**
 * Окно входа. Один и тот же вид у страницы авторизации и у окна истёкшей сессии:
 * логотип по центру и под ним форма. Закрыть окно нельзя — пока не вошли,
 * приложением всё равно не воспользоваться. Крестик не рисуется сам: без title
 * у Blueprint нет шапки, куда его поставить, поэтому и проп не нужен.
 * Вход с нового устройства продолжается здесь же вторым шагом - вводом кода.
 */
export const AuthDialog = observer(({ store, note, dimmed = true }: AuthDialogProps) => (
    <Dialog
        isOpen={true}
        canOutsideClickClose={false}
        canEscapeKeyClose={false}
        backdropClassName={dimmed ? "standard" : styles.plainBackdrop}
        className={`figma-dialog ${styles.dialog}`}
    >
        <div className={styles.header}>
            <AppLogo className={styles.logo} />

            {note && !store.waitConfirm && !store.accessBlocked && <div className={styles.note}>{note}</div>}
        </div>

        {store.accessBlocked ? (
            <AccessBlockedStep onBack={() => store.hideAccessBlocked()} />
        ) : store.waitConfirm ? (
            <DeviceStep store={store} />
        ) : (
            <AuthForm store={store} />
        )}
    </Dialog>
));

interface AuthDialogProps extends AuthFormProps {
    /** Почему просим войти: у истёкшей сессии — своя строка под логотипом */
    note?: string;

    /**
     * Затемнять фон. На странице входа затемнять нечего — под окном только
     * её собственный светлый фон, а вот приложение под истёкшей сессией гасим
     */
    dimmed?: boolean;
}
